
import GetComponentsFromBloks from "../../../helpers/bloksRenderer"

import styles from "./threeColumnLayoutPanel.module.scss"

function ThreeColumnLayoutPanel({ blok, story_language }) {
  let leftComponents = [],
      middleUpperComponents = [],
      middleLowerComponents = [],
      rightComponents = []

  if(blok && blok.left_column) {
    leftComponents = GetComponentsFromBloks(blok.left_column,{ lang: story_language })
  }
  if(blok && blok.middle_column_upper) {
    middleUpperComponents = GetComponentsFromBloks(blok.middle_column_upper,{ lang: story_language })
  }
  if(blok && blok.middle_column_lower) {
    middleLowerComponents = GetComponentsFromBloks(blok.middle_column_lower,{ lang: story_language })
  }
  if(blok && blok.right_column) {
    rightComponents = GetComponentsFromBloks(blok.right_column,{ lang: story_language })
  }

  return (
    <section className={`${styles.threeColumnLayoutPanel} ${blok.margin_top ? styles.marginTopDefault : ""} ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <div className={styles.layout}>
        <div className={styles.middleUpper}>{middleUpperComponents}</div>
        <div className={styles.left}>{leftComponents}</div>
        <div className={styles.right}>{rightComponents}</div>
        <div className={styles.middleLower}>{middleLowerComponents}</div>
      </div>
    </section>
  )
}

export default ThreeColumnLayoutPanel
